module.exports = __webpack_public_path__ + "img/Vue.ec15ec88.png";